import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

export function validateEmail(email) {
  const validRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return validRegex.test(email);
}
export const FormatUSD = (data) => {
  return Number(data)?.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });
};

export function capitalizeFirstLetter(str) {
  return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
}

export function convertSnakeCaseToDefault(str) {
  return str
    .split("_")
    .map((item) => capitalizeFirstLetter(item))
    .join(" ");
}
export function createFormData(data) {
  const formdata = new FormData();

  for (let key in data) {
    if (data.hasOwnProperty(key)) {
      formdata.append(key, data[key]);
    }
  }

  return formdata;
}

export function generateRandomId(length = 20) {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const timestamp = Date.now().toString(); // Get the numeric value from Date.now()
  const alphanumericLength = length - timestamp.length; // Calculate space for alphanumeric part

  // Generate the alphanumeric part
  let alphanumericPart = Array.from(
    { length: alphanumericLength },
    () => characters[Math.floor(Math.random() * characters.length)]
  ).join("");

  // Combine the alphanumeric part with the timestamp
  let combinedId = alphanumericPart + timestamp;

  // Shuffle the combined string to mix alphanumeric and numeric parts
  let shuffledId = combinedId
    .split("")
    .sort(() => Math.random() - 0.5)
    .join("");

  return shuffledId;
}

export const formatDateInTimeZone = (
  date,
  format = "DD-MM-YYYY",
  timeZone = "America/Chicago"
) => {
  if (!date) {
    return "N/A"; // Return "N/A" if no date is provided
  }

  // Convert UTC date to specified timezone (default: America/Chicago)
  return dayjs.utc(date).tz(timeZone).format(format);
};

export const getClassForValue = (value) => {
  if (value > 0) return "positive_value";
  if (value < 0) return "negative_value";
  return ""; // Default class if value is zero or undefined
};

export const RESET_ELIGIBLE_QUALIFIED_PLANS = [
  "Zero Plan",
  "Premium Plan",
  "Standard Plan",
];

export const isAccountResetEligible = (account) => {
  if (!account) return false;

  const phase = account.phase;
  const planName = account.plan_name;
  const status = account.status?.toLowerCase();

  const isEvaluationResettable = phase === "evaluation" && status !== "passed";
  const isQualifiedResettable =
    phase === "qualified" && RESET_ELIGIBLE_QUALIFIED_PLANS.includes(planName);

  return isEvaluationResettable || isQualifiedResettable;
};
